var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comment-replies__item" },
    [
      _c("div", { staticClass: "comment-wrapper" }, [
        _c(
          "div",
          { staticClass: "comment", attrs: { id: _vm.idSelector } },
          [
            _c("CommentHeader", { attrs: { comment: _vm.comment } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "comment__content" },
              [
                _c("CommentText", { attrs: { comment: _vm.comment } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "comment__bottom" },
                  [
                    _vm.comment.answerCount
                      ? _c(
                          "div",
                          {
                            staticClass: "comment__reply-show-more-wrapper",
                            on: { click: _vm.toggleAnswers }
                          },
                          [
                            _c("div", {
                              staticClass: "comment__reply-show-more-btn",
                              class: {
                                "comment__reply-show-more-btn--down":
                                  _vm.isAnswersShowing
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "comment__reply-show-more" },
                              [_vm._v(_vm._s(_vm.showMoreBtnText))]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isCommentShowing
                      ? _c("ReplyBtn", {
                          attrs: { "replay-to-id": _vm.comment.id }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isCommentShowing
                      ? _c("MoreActionsBtn", {
                          attrs: { comment: _vm.comment }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("LikeBtn", {
                      attrs: { comment: _vm.comment, "is-mobile": true }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "comment-answer-transform" } }, [
        _vm.isAnswersShowing
          ? _c("div", { staticClass: "comment-answer" }, [
              _c(
                "div",
                { staticClass: "comment-answer__top" },
                _vm._l(_vm.showingAnswers, function(comment) {
                  return _c("Answer", {
                    key: comment.id,
                    attrs: { comment: comment }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _vm.hasMoreAnswers
                ? _c("div", { staticClass: "comment-answer__bottom" }, [
                    _vm.showPartOfAnswers
                      ? _c(
                          "div",
                          {
                            staticClass: "comment-answer__next",
                            on: { click: _vm.showNextAnswers }
                          },
                          [
                            _c("div", {
                              staticClass: "comment-answer__next-icon"
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "comment-answer__next-text" },
                              [
                                _vm._v(
                                  "\n                        Другие ответы\n                    "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "comment-reply-wrapper" },
        [
          _c(
            "transition",
            { attrs: { name: "comment-input-fade" } },
            [
              _c("Input", {
                key: _vm.comment.id,
                attrs: { "answer-to-id": _vm.comment.id }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }